import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


import UI from './modules/ui/store'
import Auth from './modules/authentication/store'
import Messages from './modules/messages/store'
import Users from './modules/users/store'
import Roles from './modules/roles/store'
import Groups from './modules/groups/store'
import Papers from './modules/papers/store'
import Plugins from './modules/plugins/store'

export default new Vuex.Store({
    modules: {
        UI,
        Auth,
        Messages,
        Users,
        Roles,
        Groups,
        Papers,
        Plugins
    },

    state: {

    },

    getters: {

    },

    actions: {

    },

    mutations: {

    }
})



// WEBPACK FOOTER //
// ./src/stores/store.js